export default __webpack_public_path__ + "static/media/orientation.e580227e.svg";